import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { AuthGuard } from './guards/auth.guard';
//import { NonAuthGuard } from './services/non-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./views/pages/home-page/home-page.component').then(m => m.HomePageComponent),
    data: {
      title: 'Home'
    }
  },
  {
    path: 'home-page',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard], 
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'home',
        loadChildren: () => import('./views/home/routes').then((m) => m.routes)
      },
      {
        path: 'product',
        loadChildren: () => import('./views/product/routes').then((m) => m.routes)
      },
      {
        path: 'product/insurance',
        loadChildren: () => import('./views/product/insurance/routes').then((m) => m.routes)
      },
      {
        path: 'product/loans',
        loadChildren: () => import('./views/product/loans/routes').then((m) => m.routes)
      },
      {
        path: 'product/credit-card',
        loadChildren: () => import('./views/product/credit-card/routes').then((m) => m.routes)
      },
      {
        path: 'report',
        loadChildren: () => import('./views/report/routes').then((m) => m.routes)
      },
      {
        path: 'reward',
        loadChildren: () => import('./views/reward/routes').then((m) => m.routes)
      },
      {
        path: 'support',
        loadChildren: () => import('./views/support/routes').then((m) => m.routes)
      }
    ]
  },

  {
    path: 'page404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  
  // Authentication required routes
  {
    path: 'customer-q-report',
    loadComponent: () => import('./views/pages/customer-q-report/customer-q-report.component').then(m => m.CustomerQreportComponent),
    data: {
      title: 'Customer Q Report'
    }
  },
  
  {
    path: 'q-report',
    loadComponent: () => import('./views/pages/q-report/q-report.component').then(m => m.QreportComponent),
    data: {
      title: 'Q Report'
    }
  },
  
  // Registration flow routes with NonAuthGuard
  {
    path: 'customer-first-details',
    loadComponent: () => import('./views/pages/customer-first-details/customer-first-details.component').then(m => m.CustomerFirstDetailsComponent),
    data: {
      title: 'Customer Details'
    }
  },

  {
    path: 'customer-details',
    loadComponent: () => import('./views/pages/customer-details/customer-details.component').then(m => m.CustomerDetailsComponent),
    data: {
      title: 'Customer Details'
    }
  },

  {
    path: 'customer-emp',
    loadComponent: () => import('./views/pages/customer-emp/customer-emp.component').then(m => m.CustomerEmpComponent),
    data: {
      title: 'Customer Employee'
    }
  },
   {
    path: 'thank-you',
    loadComponent: () => import('./views/pages/thank-you/thank-you.component').then(m => m.ThankYouComponent),
    data: {
      title: 'Thank You'
    }
  },
  
  {
    path: 'customers-profile',
    loadComponent: () => import('./views/pages/customers-profile/customers-profile.component').then(m => m.CustomersProfileComponent),
    data: {
      title: 'Customer Employee'
    }
  },
  
  {
    path: 'customer-otp',
    loadComponent: () => import('./views/pages/customer-otp/customer-otp.component').then(m => m.CustomerOtpComponent),
    data: {
      title: 'Customer OTP'
    }
  },


  // Authentication pages with NonAuthGuard
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login'
    }
  },

  {
    path: 'otp-varification',
    loadComponent: () => import('./views/pages/otp-varification/otp-varification.component').then(m => m.OtpVarificationComponent),
    data: { title: 'OTP Verification' }
  },

  {
    path: 'update-password',
    loadComponent: () => import('./views/pages/update-password/update-password.component').then(m => m.UpdatePasswordComponent),
    data: { title: 'Update Password' }
  },
  
  { 
    path: 'create-account', 
    loadComponent: () => import('./views/pages/create-account/create-account.component').then(m => m.CreateAccountComponent), 
    data: { title: 'Create Account' } 
  },

  { 
    path: 'signin-with-otp', 
    loadComponent: () => import('./views/pages/signin-with-otp/signin-with-otp.component').then(m => m.SigninWithOtpComponent), 
    data: { title: 'Sign-In with OTP' } 
  },
  
  {
    path: 'forgot-password',
    loadComponent: () => import('./views/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    data: { title: 'Forgot Password' }
  },
  
  // Public routes - no guard needed
  {
    path: 'common-footer',
    loadComponent: () => import('./views/common/common-footer/common-footer.component').then(m => m.CommonFooterComponent),
    data: { title: 'Common Footer' }
  },
  
  {
    path: 'common-inner-footer',
    loadComponent: () => import('./views/common/common-inner-footer/common-inner-footer.component').then(m => m.CommonInnerFooterComponent),
    data: { title: 'Common Inner Footer' }
  },
  
  {
    path: 'loan-popup',
    loadComponent: () => import('./views/common/loan-popup/loan-popup.component').then(m => m.LoanPopupComponent),
    data: { title: 'Loan Popup' }
  },
  
  
  {
    path: 'blogs',
    loadComponent: () => import('./views/pages/blogs/blogs.component').then(m => m.BlogsComponent),
    data: { title: 'Blogs' }
  },
  
  {
    path: 'cookies',
    loadComponent: () => import('./views/pages/cookies/cookies.component').then(m => m.CookiesComponent),
    data: { title: 'Cookies' }
  },
  
  {
    path: 'privacy-policy',
    loadComponent: () => import('./views/pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    data: { title: 'Privacy Policy' }
  },
  
  {
    path: 'disclaimer',
    loadComponent: () => import('./views/pages/disclaimer/disclaimer.component').then(m => m.DisclaimerComponent),
    data: { title: 'Disclaimer' }
  },
  
  {
    path: 'terms-of-use',
    loadComponent: () => import('./views/pages/terms-of-use/terms-of-use.component')
      .then(m => m.TermsOfUseComponent),
    data: { title: 'Terms Of Use' }
  },
  
  
   {
    path: 'five-signs-you-are-paying-too-much-on-your-loan-emis',
    loadComponent: () => import('./views/pages/blog-pages/five-signs-you-are-paying-too-much-on-your-loan-emis/five-signs-you-are-paying-too-much-on-your-loan-emis.component')
      .then(m => m.FiveSignsYouArePayingTooMuchOnYourLoanEmisComponent),
    data: { title: 'Blog' }
  },
  
  {
    path: 'are-you-financially-overstretched',
    loadComponent: () => import('./views/pages/blog-pages/are-you-financially-overstretched/are-you-financially-overstretched.component')
      .then(m => m.AreYouFinanciallyOverstretchedComponent),
    data: { title: 'Blog' }
  },
  
  {
    path: 'are-you-paying-more-interest-than-you-should',
    loadComponent: () => import('./views/pages/blog-pages/are-you-paying-more-interest-than-you-should/are-you-paying-more-interest-than-you-should.component')
      .then(m => m.AreYouPayingMoreInterestThanYouShouldComponent),
    data: { title: 'Blog' }
  },
  {
    path: 'when-is-the-right-time-to-take-a-loan',
    loadComponent: () => import('./views/pages/blog-pages/when-is-the-right-time-to-take-a-loan/when-is-the-right-time-to-take-a-loan.component')
      .then(m => m.WhenIsTheRightTimeToTakeALoanComponent),
    data: { title: 'Blog' }
  },
  
  {
    path: 'why-your-credit-score-is-way-more-powerful-than-you-realise',
    loadComponent: () => import('./views/pages/blog-pages/why-your-credit-score-is-way-more-powerful-than-you-realise/why-your-credit-score-is-way-more-powerful-than-you-realise.component')
      .then(m => m.WhyYourCreditScoreIsWayMorePowerfulThanYouRealiseComponent),
    data: { title: 'Blog' }
  },
  
  
  {
    path: 'top-five-mistakes-people-make-while-managing-personal-loans-in-dubai',
    loadComponent: () => import('./views/pages/blog-pages/top-five-mistakes-people-make-while-managing-personal-loans-in-dubai/top-five-mistakes-people-make-while-managing-personal-loans-in-dubai.component')
      .then(m => m.TopFiveMistakesPeopleMakeWhileManagingPersonalLoansInDubaiComponent),
    data: { title: 'Blog' }
  },
  
  { 
    path: 'coming-soon', 
    loadComponent: () => import('./views/pages/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent), 
    data: { title: 'Comming Soon' } 
  },

  { path: '**', redirectTo: '' }
];